export default __webpack_public_path__ + "static/media/7.401044a7.webp";